/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { typeErrors } from "../common/data/typeErrors";

export const translateErrors = (statusCode: string): string => {
    const errorTranslated = typeErrors.filter((error) => {
        if (error.statusCode === statusCode) {
            return error.messageTranslated;
        }
    });
    if (errorTranslated.length > 0) {
        return errorTranslated[0].messageTranslated;
    } else {
        const errorTranslatedDefault = typeErrors.filter((error) => {
            if (error.statusCode === 'DEFAULT') return error.messageTranslated;
        });
        if (statusCode !== undefined) {
            return statusCode + ' - ' + errorTranslatedDefault[0].messageTranslated;
        }
        return errorTranslatedDefault[0].messageTranslated;
    }
};

export const titleCase = (str: string): string => {
    return str
        .toLowerCase()
        .split(' ')
        .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
};

export const formatPrice = (price: any, fraction: number): string => {
    if (price) {
        return parseInt(price.toString()).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: fraction });
    } else {
        return price;
    }
};

export const formatNumber = (price: number, fraction: number): string => {
    return price.toLocaleString('es-CL', { minimumFractionDigits: fraction });
};
